// ============================
// === templates/index.html ===
// ============================

htmx.on("#form-audio-upload", "htmx:xhr:progress", function (evt: any) {
  htmx
    .find("#progress")
    .setAttribute(
      "style",
      "width: " + (evt.detail.loaded / evt.detail.total) * 100,
    );
});
